import React from 'react'
import _ from 'lodash'
import * as styles from './styles'
import { DividerHeader, MinimalTable } from '../../styles/utils'
import { firstSentence, ensureWithoutTrailingDot } from '../../util'

export default ({ parameters, openapi, operationMetadata }) => {
  return (
    <styles.Container>
      <DividerHeader>Parameters</DividerHeader>

      <MinimalTable>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          { _.map(parameters, (param, i) => {
            const resolvedParam = openapi.resolveRef(param)
            const parameterSchema = openapi.getPath(resolvedParam, 'schema')

            const type = resolvedParam.__body
              ? <a href={`#${operationMetadata.id}-body`}>{parameterSchema.type}</a>
              : <span>{parameterSchema.type}</span>

            return (
              <tr key={i}>
                <td>
                  <b>
                    {resolvedParam.name}
                    <styles.Required>{resolvedParam.required ? 'required' : ''}</styles.Required>
                  </b>
                </td>
                <td>{type}</td>
                <td>{ensureWithoutTrailingDot(firstSentence(resolvedParam.description))}</td>
              </tr>
            )
          })}
        </tbody>
      </MinimalTable>
    </styles.Container>
  )
}